import { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';

export const ListContainer = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
`;

export const TableArea = styled.div`
  flex: 1;
  min-height: 240px;
  display: flex;
  flex-direction: column;
`;

export const useTableScrollHeight = (minHeight = 240) => {
  const tableAreaRef = useRef(null);
  const [scrollHeight, setScrollHeight] = useState(`${minHeight}px`);

  useLayoutEffect(() => {
    const node = tableAreaRef.current;
    if (!node) return;

    const update = () => {
      const height = node.clientHeight;
      if (height > 0) {
        setScrollHeight(`${Math.max(minHeight, height)}px`);
      }
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(node);
    window.addEventListener('resize', update);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [minHeight]);

  return { tableAreaRef, scrollHeight };
};

export const paginationComponentOptions = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

export const buildTableStyles = (rowMinHeight = '56px') => ({
  table: { style: { width: '100%' } },
  tableWrapper: { style: { width: '100%', overflowX: 'auto' } },
  headRow: {
    style: {
      backgroundColor: '#343a40',
      color: '#fff',
      fontSize: '0.78rem',
      fontWeight: '600',
      minHeight: '48px',
    },
  },
  headCells: {
    style: { paddingLeft: '12px', paddingRight: '12px' },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: '0.82rem',
    },
  },
  rows: {
    style: {
      minHeight: rowMinHeight,
      '&:hover': { backgroundColor: '#eef2f7' },
    },
    stripedStyle: { backgroundColor: '#fcfcfd' },
  },
});
